import { AxiosError, AxiosResponse } from 'axios';
import Core from '../core';
import browserTimeZone from './localtime';
async function getActiveLoans(employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmpAppliedRecurringPayments?emp_id=${employee_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getLoansFinished(employee_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/getEmpRecurringPaymentsHistory?emp_id=${employee_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getLoanTypes(company_id: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/getLoanType?company_id=${company_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function applyLoan(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.post(
    `/v1/createLoan?timeZone=${browserTimeZone}`,
    payload,
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}
export const loanService = {
  getActiveLoans,
  getLoansFinished,
  getLoanTypes,
  applyLoan,
};
